import React from 'react';
import { Row, Col, Button, Container } from 'reactstrap';
import Helper from '../../utils/helper';
import { sendAmplitudeData, amplitudeTypes } from '../../utils/amplitude';

export default class HomeGooglePlay extends React.Component {
    constructor(props) {
        super(props);
    }

    onOpenGooglePlay = () => {
        sendAmplitudeData(amplitudeTypes.CLICK_GOOGLE_PLAY, null);
    }

    onARSupportClick = () => {
        window.open("https://developers.google.com/ar/discover/supported-devices", '_blank');
    }

    render() {
        const { t, project } = this.props;        
        return (
            <div className="googlePlayRow p-2 mr-2">
                <Row>
                    <Col>
                        <span style={{ fontSize: "14px" }}>{t('homeProject.arMobile')}</span>
                    </Col>
                    <Col xs="auto">
                        <a href={Helper.AndroidMobileApp} target="_blank" onClick={this.onOpenGooglePlay}>
                            <img src="/img/google-play.png" />
                        </a>
                    </Col>
                </Row>
                <div className="arSupport" onClick={this.onARSupportClick}>{t('homeProject.arSupport')}</div>
            </div>
        );
    }
}